import type { FaqItem } from '../../components/Seo.helpers'

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'What is a sacrifice?',
    answer:
      'A sacrifice is a one-way, irreversible onchain token transfer made as part of a campaign. Every transaction is permanently and publicly recorded on the blockchain, so anyone can verify it without trusting a third party. A campaign may credit points for a sacrifice according to its published rules, but points are not guaranteed.',
  },
  {
    question: 'Does Altar guarantee points or rewards?',
    answer:
      'No. Altar is neutral, public software that records sacrifices and computes points from onchain data. Altar, votum, and the sacrifice system do not provide, issue, or guarantee any points, tokens, or rewards. Each campaign is run independently by its own operators, who set the rules — and who may change, delay, or disregard the rules they previously published. Participate only on the understanding that you may receive nothing in return.',
  },
  {
    question: 'Do I keep custody of my tokens?',
    answer:
      'You send tokens directly from your own wallet to a deposit address — there is no smart contract to approve, no custodian, and no off-chain escrow. Because the transfer is onchain it is irreversible: a sacrifice cannot be undone or refunded once sent, regardless of what a campaign does afterward.',
  },
  {
    question: 'Which tokens can I sacrifice?',
    answer:
      'Each campaign defines its own supported tokens and networks, and may change them. Connect a wallet or browse the campaign page to see the tokens a specific campaign currently accepts.',
  },
  {
    question: 'How are points calculated?',
    answer:
      'A campaign typically describes points as the USD value of a sacrifice multiplied by a rate that decays over time, so that sacrificing earlier tends to earn more points per dollar. This is only how published rules usually describe point crediting; the actual rules, rates, and whether points are credited at all are set by each campaign and may change.',
  },
  {
    question: 'Are there bonuses for early sacrificers?',
    answer:
      'A campaign may define bonus periods — for example a volume bonus for the top sacrificers by USD value, or a flat bonus over the first several steps. Bonuses are optional and defined per campaign; whether they apply, and how, is up to the campaign and may change.',
  },
  {
    question: 'When can I claim my reward?',
    answer:
      'There is no guaranteed reward. Whether points ever convert to tokens or anything else — and how, when, or to whom — is entirely up to the campaign you participate in. Altar records sacrifices and computes points from onchain data; it does not issue, custody, or guarantee any reward.',
  },
]
